import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import ProducerClientDto from '../dtos/producer-client.dto';
import PaginationFilter from '../../../common/interfaces/table/paginationFilter';
import PaginatedResponse from '../models/baseModels/paginatedResponse';

@Injectable()
export class ProducerService {
  private readonly httpClient = inject(HttpClient);

  getClients(
    producerNumber: number,
    pagination: PaginationFilter = { page: 1, pageSize: 10 },
  ) {
    return this.httpClient.get<PaginatedResponse<ProducerClientDto>>(
      `producer/${producerNumber}/clients?pageNumber=${pagination.page}&pageSize=${pagination.pageSize}`,
    );
  }
}
